/**
 * ProvincialLawsTeaser — responsive 13-tile grid linking to each
 * Canadian province + territory landlord-laws explainer page.
 * Shows ALL 13 at once so a mobile user sees the full coverage — no
 * carousel-swipe required. On <sm we stack 2 per row; on md+ we lay
 * out 3-4 per row.
 */
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { LANDING_PROVINCES } from "@/data/landing";

export default function ProvincialLawsTeaser() {
  return (
    <section id="provincial-laws" className="py-16 md:py-20 bg-slate-50 border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <div className="text-xs tracking-[0.22em] uppercase font-bold text-emerald-700">Landlord laws by province</div>
          <h2 className="font-display mt-3 text-2xl sm:text-3xl md:text-4xl font-bold tracking-tighter text-slate-900 leading-[1.05]">
            13 provinces &amp; territories — at a glance.
          </h2>
          <p className="mt-4 text-base md:text-lg text-slate-600 leading-relaxed">
            Notice periods, security deposits, rent-increase caps and right-of-entry rules summarized in plain language. Pick your province.
          </p>
        </div>
        <div className="mt-8 grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 gap-2" data-testid="provincial-laws-grid">
          {LANDING_PROVINCES.map(([code, name]) => (
            <Link
              key={code}
              to={`/laws/${code}`}
              data-testid={`provincial-link-${code}`}
              className="group bg-white border border-slate-200 hover:border-emerald-300 hover:shadow-md transition-all rounded-lg px-2.5 py-2.5 flex items-center justify-between gap-1.5"
            >
              <div className="min-w-0">
                <div className="text-[9px] uppercase tracking-[0.14em] font-bold text-emerald-700">{code}</div>
                <div className="text-xs font-bold text-slate-900 mt-0.5 leading-tight truncate">{name}</div>
              </div>
              <ArrowRight className="w-3 h-3 text-slate-400 group-hover:text-emerald-700 group-hover:translate-x-0.5 transition-all flex-none" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
